
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impferinnerungstext from '@/types/Impferinnerungstext';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { Impferinnerungstextart, ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import {
        DeleteImpferinnerungstextPayload,
        ImpferinnerungstexteFilter,
        UpdateImpferinnerungstextPayload,
    } from '@/store/impferinnerungstexte';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('impferinnerungstexte', ['loaders', 'platzhalter', 'arten']),
            ...mapGetters('authentication', ['isAllowed']),
        },
        methods: {
            ...mapActions('impferinnerungstexte', [
                'updateImpferinnerungstext',
                'deleteImpferinnerungstext',
                'loadImpferinnerungstextarten',
            ]),
            ...mapMutations('impferinnerungstexte', ['setDialogsDetail']),
        },
    })
    export default class ImpferinnerungstexteDetail extends Vue {
        @Prop() impferinnerungstext!: Impferinnerungstext;
        @Prop() filter!: ImpferinnerungstexteFilter;
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
            text: Vue;
        };

        public rules!: ValidationRules;
        public arten!: Impferinnerungstextart[];
        public updateImpferinnerungstext!: (payload: UpdateImpferinnerungstextPayload) => void;
        public deleteImpferinnerungstext!: (payload: DeleteImpferinnerungstextPayload) => void;
        public loadImpferinnerungstextarten!: () => void;

        public textErrorMessage = '';

        public get isEdit(): boolean {
            return this.impferinnerungstext.impferinnerungstext_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                if (this.impferinnerungstext.text === null) {
                    this.impferinnerungstext.text = '';
                }

                this.loadImpferinnerungstextarten();
            }

            if (!this.isEdit && this.$refs.text?.$refs?.content) {
                (this.$refs.text.$refs.content as HTMLElement).innerHTML = '';
            }

            this.textErrorMessage = '';
        }

        public validateText(): void {
            this.textErrorMessage = '';

            if (this.impferinnerungstext.text === '<p></p>') {
                this.impferinnerungstext.text = '';
            }

            for (const rule of [this.rules.required]) {
                const result = rule(this.impferinnerungstext.text);
                if (result !== true) {
                    this.textErrorMessage = result as string;
                    break;
                }
            }
        }

        public onClickSave(): void {
            this.validateText();

            if (this.$refs.form.validate() && this.textErrorMessage === '') {
                this.updateImpferinnerungstext({
                    impferinnerungstext: this.impferinnerungstext,
                    filter: this.filter,
                });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Impferinnerungstext endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteImpferinnerungstext({
                            impferinnerungstext: this.impferinnerungstext,
                            filter: this.filter,
                        });
                    }
                });
        }

        public get textLabelClass(): string {
            return this.textErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }
    }
